
export default {

    /*
     integer
     License Product ID.

     Holdem Manager 3:

     10 = Holdem All Stakes
     20 = Holdem Small Stakes
     11 = Holdem Trial
     14 = Holdem Freemium
     18 = Holdem Maint. Contract

     Omaha Manager 3:

     12 = Omaha All Stakes
     21 = Omaha Small Stakes
     13 = Omaha Trial
     15 = Omaha Freemium
     19 = Omaha Maint. Contract
         *
    * */
    hm3AllStakes: 10,
    hm3SmallStakes: 20,
    hm3Trial: 11,
    hm3Freemium: 14,
    hm3Maintenance: 18,

    omahaAllStakes: 12,
    omahaSmallStakes: 21,
    omahaTrial:  13,
    omahaFreemium: 15,
    omahaMaintenance: 19,


    isHm3: function (id) {
        switch (id) {
            case this.hm3AllStakes:case this.hm3SmallStakes:case this.hm3Trial:case this.hm3Freemium:case this.hm3Maintenance:
                return true;
        }
        return false;
    },

    isOmaha: function (id) {
        return !this.isHm3(id);
    },

    isTrial: function(id) {
        return id == this.hm3Trial || id == this.omahaTrial;
    },

    isFreemium: function(id) {
        return id == this.hm3Freemium || id == this.omahaFreemium;
    },

    isAllStakes: function(id) {
        return id == this.hm3AllStakes || id == this.omahaSmallStakes;
    },

    isSmallStakes: function(id) {
        return id == this.hm3SmallStakes || id == this.omahaSmallStakes;
    },

    isMaintenanceContract: function(id) {
        return id == this.hm3Maintenance || id == this.omahaMaintenance;
    },



}


// WEBPACK FOOTER //
// ./src/api/productIds.js